import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import rootReducer from '../reducers/index';
import api from '../api';
import createClientMiddleware from './clientMiddleware';
var router = routerMiddleware(browserHistory);

export default function create() {

  var clientMiddleware = createClientMiddleware(api);
  
  if(__DEVTOOLS__) {
    var { composeWithDevTools } = require('redux-devtools-extension');
    var composeEnhancers = composeWithDevTools({});

    var store = createStore(
      rootReducer,
      composeEnhancers(
        applyMiddleware(clientMiddleware, thunk, router)
      )
    );
  } else {
    var store = createStore(
      rootReducer,
      applyMiddleware(clientMiddleware, thunk, router)
    );
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      var nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}




// WEBPACK FOOTER //
// ./app/redux/create.js